(function () { if (!LN.Core || !LN.Config) throw new Error("LN.Core || LN.Config missing"); })();

(function (SWG) {

  SWG.ctor = function (subscriptions) {
    this.subscriptions = subscriptions;
    this.subscriptions.init('lanacion.com.ar:acceso_digital');
    this.subscriptions.setOnSubscribeResponse(
      this.subscribeResponse_.bind(this));

    this.subscriptions.setOnEntitlementsResponse(function () { console.log('setOnEntitlementsResponse Event'); });
    this.subscriptions.setOnLoginRequest(function () { console.log('setOnLoginRequest Event'); });
    this.subscriptions.setOnLinkComplete(function () { console.log('setOnLinkComplete Event'); });

    this.entitlements = null;
  };


  SWG.start = function (callback) {
    (window.SWG = window.SWG || []).push(function (subscriptions) {    
      SWG.ctor(subscriptions);
      callback();
    });
  };


  SWG.drawButton = function (containerId, sku) {
    if (!this || !this.subscriptions)
      throw 'SWG is not initialized';
    let currentSubscriptions = this.subscriptions;
    document.getElementById(containerId).appendChild(currentSubscriptions.createButton(function () {
      currentSubscriptions.subscribe(sku);
    }));
  };

  SWG.subscribeResponse_ = function (promise) {
    promise.then((function (response) {
      // TODO: Start account creation flow.
      console.log('got subscription response', response);
      // TODO: wait for account creation to be complete.
      setTimeout((function () {
        response.complete().then((function () {
          console.log('subscription has been confirmed');
        }).bind(this));
      }).bind(this), 8000);
    }).bind(this), function (reason) {
      console.log('subscription response failed: ', reason);
      throw reason;
    });
  };

  SWG.setOnEntitlementsResponse = function (entitlementsPromise) {
    entitlementsPromise.then((function (entitlements) {

      if (!entitlements.enablesThis()) {
        return;
      }

      log('got entitlements: ', entitlements, entitlements.enablesThis());
      if (this.completeDeferredAccountCreation_(entitlements)) {
        return;
      }
      if (entitlements && entitlements.enablesThis()) {
        // Entitlements available: open access.
        this.openPaywall_();
        entitlements.ack();
      } else {
        // In a simplest case, just launch offers flow.
        this.subscriptions.showOffers();
      }
    }).bind(this), function (reason) {
      log('entitlements failed: ', reason);
      throw reason;
    });
  };

})(LN.SWG, LN.View, LN.Config, LN.Helper, LN.Service, LN.Handler, LN.Model, LN.Message, LN.Validation, LN.Analytics, LN.Hotjar, jQuery);




// WEBPACK FOOTER //
// ./Statics/scripts/paywall/controllers/swgController.js